<template>
    <el-container class="container">
        <el-header class="header">
            <ul class="header-left">
                <li>
                    <img src="../assets/images/logo.png" />
                </li>
            </ul>
            <ul class="header-right">
                <!-- <li>
          <span>帮助</span>
        </li> -->
                <li>
                    <el-dropdown @command="doDropdownClick">
                        <span class="el-dropdown-link">
                            欢迎您，{{ user.name }}
                            <i class="el-icon-arrow-down el-icon--right"></i>
                        </span>
                        <el-dropdown-menu slot="dropdown">
                            <el-dropdown-item command="profile">
                                修改密码
                            </el-dropdown-item>
                            <el-dropdown-item divided command="logout">
                                退出登录
                            </el-dropdown-item>
                        </el-dropdown-menu>
                    </el-dropdown>
                </li>
            </ul>
        </el-header>
        <el-container>
            <el-aside class="aside">
                <el-menu ref="menu" unique-opened @select="doMenuSelete" :default-active="menuIndex" :default-openeds="menuPaths" background-color="#545c64" text-color="#fff" active-text-color="#fff">
                    <template v-for="item in menus">
                        <el-menu-item v-if="item.subs === undefined" v-has="item.role" :index="item.code" :key="item.code">
                            <span slot="title">{{ item.name }}</span>
                        </el-menu-item>
                        <el-submenu v-else v-has="item.role" :index="item.code" :key="item.code">
                            <template slot="title">
                                <span slot="title">{{ item.name }}</span>
                            </template>
<template v-for="sub in item.subs">
                                <el-menu-item v-if="sub.subs === undefined" v-has="sub.role" :index="sub.code" :key="sub.code">
                                    <span slot="title">{{ sub.name }}</span>
                                </el-menu-item>
                                <el-submenu v-else v-has="sub.role" :index="sub.code" :key="sub.code">
                                    <template slot="title">
                                        <span slot="title">{{ sub.name }}</span>
                                    </template>
<template v-for="sub2 in sub.subs">
                                        <el-menu-item v-if="sub2.subs === undefined" v-has="sub2.role" :index="sub2.code" :key="sub2.code">
                                            <v-icon :name="sub2.icon" class="main-menu-item-icon" fixed-width />
                                            <span slot="title">{{ sub2.name }}</span>
                                        </el-menu-item>
                                        <el-submenu v-else v-has="sub2.role" :index="sub2.code" :key="sub2.code">
                                            <template slot="title">
                                                <span slot="title">{{ sub2.name }}</span>
                                            </template>
</el-submenu>
</template>
</el-submenu>
</template>
</el-submenu>
</template>
</el-menu>
</el-aside>
<el-main class="main">
    <el-card shadow="never" class="breadcrumb">
        <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item>
                <i class="el-icon-menu"></i> 台前人社局
            </el-breadcrumb-item>
            <el-breadcrumb-item v-for="item in breadcrumb" :key="item">{{ item }}</el-breadcrumb-item>
        </el-breadcrumb>
    </el-card>
    <router-view></router-view>
</el-main>
</el-container>
</el-container>
</template>

<script>
    import MD5 from 'crypto-js/md5'
    import menus from '../libs/menu'

    export default {
        name: 'Main',
        data() {
            return {
                menus: menus,
                menuIndex: sessionStorage.getItem('App.ActiveMenuIndex') || 'ui.index',
                menuPaths: JSON.parse(sessionStorage.getItem('App.ActiveMenuPaths') || '[]')
            }
        },
        computed: {
            breadcrumb() {
                return JSON.parse(this.$store.state.Breadcrumb.paths)
            },
            user() {
                return this.$store.state.User
            }
        },
        methods: {
            doDropdownClick(cmd) {
                if (cmd === 'logout') {
                    this.$confirm('是否注销登录当前用户?', '提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning'
                    }).then(() => {
                        this.$http
                            .post('/comm/user/signout', {
                                uid: this.user.id
                            })
                            .then(result => {
                                if (result.code === 0) {
                                    this.$store.commit('signout')
                                    this.$router.push({
                                        name: 'guest.login'
                                    })
                                }
                            })
                    })
                } else if (cmd === 'profile') {
                    this.$prompt('请输入新密码', '修改登录密码', {
                            confirmButtonText: '确定',
                            cancelButtonText: '取消',
                            inputPlaceholder: '请输入6-15位密码，支持数字和字母',
                            inputPattern: /^[a-zA-Z0-9]{6,15}$/,
                            inputErrorMessage: '6-15位密码，支持数字和字母'
                        })
                        .then(({
                            value
                        }) => {
                            this.$http
                                .post('/comm/user/passwd', {
                                    pwd: MD5(MD5(value).toString()).toString()
                                })
                                .then(result => {
                                    if (result.code === 0) {
                                        this.$store.commit('signout')
                                        this.$router.push({
                                            name: 'guest.login'
                                        })
                                    }
                                })
                        })
                        .catch(() => {})
                }
            },
            doMenuSelete(index, paths) {
                sessionStorage.setItem('App.ActiveMenuIndex', index)
                if (index === 'ui.index') {
                    sessionStorage.setItem('App.ActiveMenuPaths', '[]')
                } else {
                    sessionStorage.setItem('App.ActiveMenuPaths', JSON.stringify(paths))
                }
                this.$router.push({
                    name: index
                })
            }
        }
    }
</script>

<style scoped>
    .container {
        height: 100vh !important;
    }
    
    .header {
        vertical-align: middle;
        padding: 0;
        color: #ffffff;
        line-height: 50px !important;
        height: 50px !important;
        background-color: #393939;
    }
    
    .header-left {
        height: 50px;
        width: auto;
        vertical-align: middle;
        list-style: none;
        float: left;
    }
    
    .header-left li {
        display: inline-block;
        vertical-align: middle;
        line-height: 50px !important;
        text-align: center;
    }
    
    .header-right {
        height: 50px;
        width: auto;
        vertical-align: middle;
        list-style: none;
        float: right;
        padding-right: 20px;
    }
    
    .header-right li {
        cursor: pointer;
        display: inline-block;
        vertical-align: middle;
        padding: 0 10px;
        line-height: 50px;
        text-align: center;
    }
    
    .header-right span {
        color: white;
        font-size: 1em;
    }
    
    .header-right img {
        height: 40px;
        width: 40px;
        vertical-align: middle;
        border-radius: 50%;
    }
    
    .aside {
        max-width: 200px !important;
        width: 200px !important;
        border-right: 0;
        color: #e6f7ff;
        background-color: #545c64;
    }
    
    .el-menu {
        border-right: 0;
    }
    
    .is-active {
        background-color: #1890ff !important;
    }
    /*
  .is-opened .el-submenu__title {
    background-color: #1890ff !important;
  } */
    
    .main {
        background-color: #f1f2f6;
        height: calc(100vh - 50px);
    }
    
    .main .breadcrumb {
        margin-bottom: 20px;
    }
    
    .footer {
        height: 50px !important;
        background-color: cyan;
    }
</style>